import { render } from "./register_dialog_content.vue?vue&type=template&id=10219a4a&ts=true"
import script from "./register_dialog_content.vue?vue&type=script&lang=ts"
export * from "./register_dialog_content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__